import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api/client'
import type { PanelRelease, Release } from '../shared/types'

export const useReleases = (accountId?: string) =>
  useQuery({
    queryKey: ['releases', accountId ?? ''],
    queryFn: () => api.get<Release[]>('/api/v1/releases', { account_id: accountId }),
  })

export const usePanelReleases = () =>
  useQuery({
    queryKey: ['panel-releases'],
    queryFn: () => api.get<PanelRelease[]>('/api/v1/panel-releases'),
  })

export function useUpdatePanelRelease() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, ...body }: { id: string; notes: string; min_server_version: string }) =>
      api.put(`/api/v1/panel-releases/${id}`, body),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['panel-releases'] }),
  })
}

export function usePublishPanelRelease() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.put(`/api/v1/panel-releases/${id}/publish`),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['panel-releases'] }),
  })
}
